import { render } from "./SubscribePage.vue?vue&type=template&id=178e5bb6"
import script from "./SubscribePage.vue?vue&type=script&lang=js"
export * from "./SubscribePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__